import { FC, useCallback, useState } from "react";

import { ErrorWithRetry } from "@/components/ui";

import MidtermsTracker from "./MidtermsTracker";
import { loadSettings, saveSettings } from "./storage";
import type { ModelSettings } from "./types";
import useExternalSources from "./useExternalSources";
import useMidtermsData from "./useMidtermsData";

/** Admin page body: the tracker studies' latest runs, loaded live, next to
    published forecasts, with field waves and publishing. */
const AdminTracker: FC = () => {
  const data = useMidtermsData();
  const comparison = useExternalSources();
  const [settings, setSettings] = useState<ModelSettings>(loadSettings);

  const updateSettings = useCallback((next: ModelSettings) => {
    setSettings(next);
    saveSettings(next);
  }, []);

  if (
    data.error &&
    Object.keys(data.samples).length === 0 &&
    data.studies.length === 0
  ) {
    return (
      <ErrorWithRetry
        error={data.error}
        onRetry={data.refresh}
        retrying={data.loading}
      />
    );
  }

  return (
    <MidtermsTracker
      mode={{ comparison, data, variant: "admin" }}
      onSettingsChange={updateSettings}
      settings={settings}
    />
  );
};

export default AdminTracker;
